module.exports = "/images/qizhi_f9325b.png";